export default function () {
    /**
     * Sticky header
     */
    document.addEventListener('DOMContentLoaded', () => {
        const header = document.getElementById('header')
        if (!header) return

        const STICKY_CLASS = 'sticky'
        const sentinel = document.createElement('div')
        header.before(sentinel)

        const observer = new IntersectionObserver(([entry]) => {
            header.classList.toggle(STICKY_CLASS, !entry.isIntersecting)
        })

        observer.observe(sentinel)
    })


    document.addEventListener('DOMContentLoaded', () => {
        const toggleBtn = document.querySelector('[data-mobile-menu-toggle]')
        const drawer = document.querySelector('[data-mobile-menu-drawer]')
        const overlay = document.querySelector('[data-mobile-menu-overlay]')
        const container = document.querySelector('[data-mobile-menu-container]')
        const closeBtn = document.querySelector('[data-mobile-menu-close]')
        const body = document.querySelector('body')

        const openMenu = () => {
            if (!toggleBtn || !drawer || !overlay || !container) return

            drawer.classList.add('is-active')
            overlay.classList.add('is-active')
            container.classList.add('is-active')
            body?.classList.add('no-scroll')
        }

        const closeMenu = () => {
            if (!toggleBtn || !drawer || !overlay || !container) return

            drawer.classList.remove('is-active')
            overlay.classList.remove('is-active')
            container.classList.remove('is-active')
            body?.classList.remove('no-scroll')
            resetMobileMenuDepth()
        }

        if (!toggleBtn || !drawer || !overlay) return

        toggleBtn.addEventListener('click', (e) => {
            e.preventDefault()
            if (drawer.classList.contains('is-active')) {
                closeMenu()
            } else {
                openMenu()
            }
        })

        closeBtn?.addEventListener('click', (e) => {
            e.preventDefault()
            closeMenu()
        })

        container?.addEventListener('click', (e) => {
            if (e.target && e.target.href && e.target.href.includes('#')) {
                closeMenu()
            }
        })

        overlay.addEventListener('click', closeMenu)

        window.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                closeMenu()
            }
        })
        document.addEventListener("click", e => {
            if (e.target.closest(".submenu-toggle")) {
                const btn = e.target.closest(".submenu-toggle");
                const submenu = btn.parentElement.querySelector(".dropdown-menu");
                submenu.classList.add("active");
                btn.closest("ul").classList.add("hidden");
            }

            if (e.target.closest(".back-button")) {
                const btn = e.target.closest(".back-button");
                const submenu = btn.closest(".dropdown-menu");
                submenu.classList.remove("active");
                submenu.parentElement.closest("ul").classList.remove("hidden");
            }
        });
    })

    function resetMobileMenuDepth() {
        const levels = document.querySelectorAll(".main-navigation-mobile .dropdown-menu.active")

        if(levels.length === 0) return
        levels.forEach(level => {
            level.classList.remove("active")
        })
    }

    function handleDropdownMenu() {
        document.querySelectorAll(".main-navigation-desktop .has-dropdown").forEach(item => {
            let timer: number;

            item.addEventListener("mouseenter", () => {
                clearTimeout(timer);
                item.classList.add("open");
            });

            item.addEventListener("mouseleave", () => {
                timer = setTimeout(() => {
                    item.classList.remove("open");
                }, 200);
            });
        });
    }



    document.addEventListener('DOMContentLoaded', () => {
        handleDropdownMenu();
    })

}
